import React, { useMemo, useCallback } from 'react';

import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Button,
  Alert,
} from 'reactstrap';

import WorkflowHttpRequestOutputStageFormFileItemAttributes from './attributes';

const WorkflowHttpRequestOutputStageFormFileItemList = props => {

  const {
    currentNode,
    callbacks: {
      onSetCurrentNode
    }
  } = props;

  const fileItems = useMemo(() => {
    return currentNode?.data['output_stage_form']['file_items'] || [];
  }, [currentNode?.data['output_stage_form']['file_items']])

  const generateCustomId = useMemo(() => {
    return `${ Math.random().toString(36).slice(2) }-${ moment().toDate().getTime() }-${ fileItems.length }`;
  }, [fileItems.length])

  const onAddFileItem = () => {
    const fileItemAttributes = {
      id: '',
      name: '',
      is_required: false,
      _destroy: false,
      custom_id: generateCustomId
    }

    if(_.isFunction(onSetCurrentNode)){
      onSetCurrentNode(prevState => {
        prevState.data['output_stage_form']['file_items'] = [
          ... prevState.data['output_stage_form']['file_items'],
          fileItemAttributes
        ]

        return { ... prevState }
      })
    }
  }

  // ---------- START FILE ITEMS ATTRIBUTES ----------
  const onChangeFileItem = useCallback((fileItem, customId) => {
    onSetCurrentNode(prevState => {
      return {
        ...prevState,
        data: {
          ...prevState.data,
          output_stage_form: {
            ...prevState.data.output_stage_form,
            file_items: _.map(prevState.data.output_stage_form.file_items, item => {
              if(item.custom_id == customId){
                return fileItem
              } else {
                return item
              }
            })
          }
        }
      }
    })
  }, [fileItems])
  // ---------- END FILE ITEMS ATTRIBUTES ----------

  // WorkflowHttpRequestOutputStageFormFileItemAttributes

  const fileItemsAttributes = () => {
    if(fileItems.length > 0){
      return(
        <Table>
          <thead>
            <tr>
              <th>{ I18n.t('activerecord.attributes.workflow/stage_file_item.name') }</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            { _.map(fileItems, (fileItem) => {
              return(
                <WorkflowHttpRequestOutputStageFormFileItemAttributes
                  key={ `WorkflowHttpRequestOutputStageFormFileItemAttributes-${ fileItem.custom_id }` }
                  fileItem={ fileItem }
                  callbacks={{
                    onChangeFileItem: onChangeFileItem
                  }}
                />
              )
            })}
          </tbody>
        </Table>
      )
    } else {
      return(
        <Alert color="primary" className="text-center" role="alert" fade={ false }>
          <i className="fas fa-info-circle mr-2" aria-hidden="true" title="Información"/>
          Aún no has agregado documentos
        </Alert>
      )
    }
  }

  return (
    <Row>
      <Col md={ 12 }>
        <Card>
          <CardHeader>
            <div className="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap">
              <div className="font-weight-bold">
                <i className="fas fa-copy mr-2"></i>
                { I18n.t('activerecord.models.workflow/stage_file_item.other') }
              </div>

              <div className="text-end">
                <Button
                  outline
                  color='success'
                  size="sm"
                  onClick={ onAddFileItem }
                >
                  { I18n.t('actions.add') }
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            { fileItemsAttributes() }
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default WorkflowHttpRequestOutputStageFormFileItemList;
